// extracted by mini-css-extract-plugin
export default {"message":"RouteChangeConfirmationPopup_message__vg1N5"};